export function createBreadcrumbJson(list) {
  const breadcrumb = list.map((value, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: value.name,
      item: value.url,
    };
  });

  const json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumb,
  };

  return json;
}

export function getBreadcrumbStepProduct(slug, index) {
  const step = slug.slice(0, index + 1).join('/');
  if (index === slug.length - 1) {
    return {
      url: `${process.env.domain}/products/${step}/`,
      name: slug[index].split('-')[0],
    };
  }
  return {
    url: `${process.env.domain}/categories/${step}/`,
    name: slug[index],
  };
}

export function getBreadcrumbValidation(data) {
  if (data.length === 4) {
    return [...data.slice(0, 2), ...data.slice(3)];
  }
  return data;
}

export function getBreadcrumbTwoStep(link) {
  const firstStep = link.split('/')[0];
  return [
    {
      url: `${process.env.domain}/${firstStep}/`,
      name: firstStep,
    },
    {
      url: `${process.env.domain}/${link}/`,
      name: link.split('/')[1],
    },
  ];
}

export default { createBreadcrumbJson, getBreadcrumbStepProduct, getBreadcrumbTwoStep, getBreadcrumbValidation };
